import * as yup from 'yup';
import FormFieldType from 'src/shared/ui/components/Form/FormFieldFactory/FormFieldType';

const canShowCompanyHeadquarterField = (userHeadquarterList, fields) => {
  if (!fields || !fields.companyHeadquarterListId) {
    return true;
  }

  return fields.companyHeadquarterListId.every((companyHeadquarterId) => {
    return userHeadquarterList
      .map((x) => x.CompanyHeadquarter.id)
      .includes(companyHeadquarterId);
  });
};

const Employee = ({
  fields,
  backofficeUserList,
  userHeadquarterList,
  selectedUserHeadquarter
}) => [
  {
    name: 'companyHeadquarterListId',
    validation: yup
      .array()
      .of(yup.string())
      .nullable(false),
    type: FormFieldType.SELECT_CHIP,
    value:
      fields && fields.companyHeadquarterListId
        ? fields.companyHeadquarterListId
        : [selectedUserHeadquarter],
    options: userHeadquarterList.map((x) => {
      return { id: x.CompanyHeadquarter.id, name: x.CompanyHeadquarter.name };
    }),
    fullWidth: true,
    enabled: canShowCompanyHeadquarterField(userHeadquarterList, fields)
  },
  {
    name: 'firstname',
    validation: yup.string().required('fieldRequired'),
    type: FormFieldType.TEXT_FIELD,
    value: fields && fields.firstname ? fields.firstname : '',
    readonly: fields && fields.id
  },
  {
    name: 'surnames',
    validation: yup.string().required('fieldRequired'),
    type: FormFieldType.TEXT_FIELD,
    value: fields && fields.surnames ? fields.surnames : '',
    readonly: fields && fields.id
  },
  {
    name: 'department',
    validation: yup.string().nullable(true),
    type: FormFieldType.SELECT,
    value: fields && fields.department ? fields.department : '',
    options: [
      'SELLS',
      'INSTALLATION_TECHNICIAN',
      'MONEY_COLLECTION',
      'ATC'
    ].map((x) => {
      return { id: x, name: x };
    })
  },
  {
    name: 'contractBeginDate',
    validation: yup.date().required('fieldRequired'),
    type: FormFieldType.DATE,
    value:
      fields && fields.contractBeginDate ? fields.contractBeginDate : new Date()
  },
  {
    name: 'document',
    validation: yup.string().required('fieldRequired'),
    type: FormFieldType.TEXT_FIELD,
    value: fields && fields.document ? fields.document : '',
    readonly: fields && fields.id
  },
  {
    name: 'email',
    validation: yup.string().required('fieldRequired'),
    type: FormFieldType.TEXT_FIELD,
    value: fields && fields.email ? fields.email : ''
  },
  {
    name: 'phone1',
    validation: yup.string().required('fieldRequired'),
    type: FormFieldType.TEXT_FIELD,
    value: fields && fields.phone1 ? fields.phone1 : ''
  },
  {
    name: 'phone2',
    validation: yup.string(),
    type: FormFieldType.TEXT_FIELD,
    value: fields && fields.phone1 ? fields.phone1 : ''
  },
  {
    name: 'userId',
    validation: yup.string().nullable(true),
    type: FormFieldType.SELECT,
    value: fields && fields.userId ? fields.userId : '',
    options: backofficeUserList.map((x) => {
      return { id: x.id, name: `${x.firstname} ${x.surnames}` };
    })
  },
  {
    name: 'comments',
    validation: yup.string(),
    type: FormFieldType.TEXT_AREA,
    value: fields && fields.comments ? fields.comments : ''
  }
];

export default Employee;
